import {
  Injectable,
  signal,
  computed,
  OnDestroy,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService implements OnDestroy {
  private readonly compactMax = 599;
  private readonly mediumMax = 839;

  private readonly _width = signal(window.innerWidth);
  readonly width = computed(() => this._width());

  readonly isCompact = computed(() => this.width() <= this.compactMax);
  readonly isMedium = computed(
    () => this.width() > this.compactMax && this.width() <= this.mediumMax
  );
  readonly isDesktop = computed(() => this.width() > this.mediumMax);

  readonly current = computed<'compact' | 'medium' | 'desktop'>(() => {
    if (this.isCompact()) return 'compact';
    if (this.isMedium()) return 'medium';
    return 'desktop';
  });

  private readonly resizeListener = () => this._width.set(window.innerWidth);

  constructor() {
    window.addEventListener('resize', this.resizeListener, { passive: true });
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }
}
